import React from 'react';
import { Typography, CardMedia } from '@material-ui/core';
import ES from 'components/ExplainString';
import explains from 'data/explains'

const data = (
<Typography component="div">
  <h1>Raft</h1>

  <h2>Background</h2>
  <p>
    This project is part of a 3rd-year course at Imperial. The Raft coursework is written using <ES {...explains['Elixir']} >Elixir</ES> with help from the <ES {...explains['Beam']}>Erlang Beam</ES>.
  </p>

  <p>
    RAFT is an acronym for Reliable, Replicated, Redundant and Fault-Tolerant consensus algorithm. This consensus algorithm has the same property as Paxos, which can resist non-byzantine faults such as Fail-Stop and network partition with the cost of availability.
  </p>

  <h2>The Scope Of the Coursework</h2>
  <p>
    This coursework implemented the <ES {...explains['RaftPaper']}>Raft paper published by Diego Ongaro and John Ousterhout</ES> up to membership change. To fully test this disturbed algorithm, I also devised a monitor that will collect information in each node and verify the correctness of the implementation.
  </p>

  <p>
    To test the robustness of the implementation, I also made an extension on the protocol which can command each node to go to sleep, force timeout and crash. By leveraging this protocol, I then extend the test bench such that you can specify nodes to crash and recover at a specific time. Allowing write more interesting test cases.
  </p>

  <h2>Raft Implementation and Testing</h2>
  <p>
    The report attached below contains description about this coursework.
  </p>

  <h2>Outcome</h2>
  <p>
    Our raft implementation are fully correct and test bench has unique designs for simulating failure, resulting 100% for this coursework.
    <br/>
    In term of personal growth, I learned details about Raft and understand why Raft variant (etcd) is used by Kubernetes for service discovery and state storage. In addition, I also learned Elixir and how to write functional language in general.
  </p>
</Typography>
)
export default data